import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { omit } from "lodash";

import Page from "../components/Page";
import Detail from "../components/Detail";

import { fetchGameData } from "../store/actions";

import Layout from "../Layout";

function DetailPage({ gameId, theme }) {
  const dispatch = useDispatch();
  const selectedGame = useSelector((state) => state.game.selected);

  useEffect(() => {
    dispatch(fetchGameData(gameId));
  }, []);

  useEffect(() => {
    if (!selectedGame) return;

    saveToLocalStorage();
  }, [selectedGame]);

  const saveToLocalStorage = () => {
    //_rpg = recent played games
    const _rpg = localStorage.getItem("_rpg");

    const recentGames = JSON.parse(_rpg);

    // if (!recentGames || recentGames.length === 0) {
    //   localStorage.setItem(
    //     "_rpg",
    //     JSON.stringify([omit(selectedGame, "gameData")])
    //   );
    // }

    if (recentGames && !recentGames.find((g) => g._id === selectedGame._id)) {
      let updatedGames = recentGames;

      if (recentGames.length > 3) {
        updatedGames = updatedGames.slice(0, 3);
      }

      updatedGames.unshift(omit(selectedGame, "gameData"));

      // localStorage.setItem("_rpg", JSON.stringify(updatedGames));
    }
  };

  return (
    <Layout>
      <Page>
        <Detail selectedGame={selectedGame} theme={theme} />

        <></>
      </Page>
    </Layout>
  );
}

export default DetailPage;
